module.exports = __webpack_public_path__ + "media/images/map-icons/icon2_unselected@3x-1e7adb367dc610885f27e0968e449ae3.png";